import KJUR from 'jsrsasign'
import uuidv1 from 'uuid/v1'
import store from '@/store/store'
import config from '@/config/config'

// 生成jwtToken
function createGuestPayload() {
  let payload = {
    jti: uuidv1(),
    iss: 'idaddy001',
    iat: ~~(new Date().getTime() / 1000),
    v: 'a@1',
    did: '1B3523A5-2D8D-456C-A4C3-A37BC74BCE73'
  }
  return JSON.stringify(payload)
}
function createUserPayload(token) {
  let payload = {
    jti: uuidv1(),
    iss: 'idaddy001',
    iat: ~~(new Date().getTime() / 1000),
    v: 'a@1',
    did: '1B3523A5-2D8D-456C-A4C3-A37BC74BCE73',
    ut: token,
    ut1: store.getters.token
  }
  return JSON.stringify(payload)
}
// 生成头部信息
export function genRequestHeaders() {
  let header = JSON.stringify({ alg: 'HS256', typ: 'JWT' })
  let secretKey = ''
  const env = config.env
  if (env == 'wt2' || env == 'dev' || env == 'local') {
    secretKey = '7d88bb0df50d0fbdc95feea2e2ee426f6961792e' // dev/wt2
  } else {
    secretKey = '042976fe08d7d459d88869e29c22a860f629eed8' // wt1/prod
  }
  let payload = ''
  payload = createGuestPayload()
  if (store.getters.v4token) {
    payload = createUserPayload(store.getters.v4token)
  } else {
    payload = createGuestPayload()
  }
  let jwtToken = KJUR.jws.JWS.sign('HS256', header, payload, { utf8: secretKey })
  let requestHeaders = {
    'Authorization': `Bearer ${jwtToken}`,
    'Grpc-Metadata-Igo-Caller': store.getters.ilistenCaller,
    'Grpc-Metadata-Igo-Prd-Ver': store.getters.ilistenPrdVer,
    'Grpc-Metadata-Igo-Channel': store.getters.ilistenChannel
  }
  return requestHeaders
}
